import { PaginatedResponse } from  "@/interfaces/api/PaginatedResponse";
import { IHttpRequest } from  "@/interfaces/IHttp";
import { container, TYPES } from  "@/inversifyconfig/container.config";

import { IUserGroupData, IWorkspaceUserGroupData } from  '@/interfaces/orgSettings';
import { IUserWorkspaceData } from  "@/interfaces/workspaces";



const http = container.get<IHttpRequest>(TYPES.IHttpRequest); 

export async function getAllUserGroups(params: any, options?: { signal?: AbortSignal }): Promise<PaginatedResponse<IUserGroupData>> {
    const url = `groups`;

    try {
        const res = await http.get(url, { params, signal: options?.signal});

        if (res) {
            return Promise.resolve(res.data);
        }
    } catch (error) {
        throw error;
    }
}


export async function setOrganisationRoleForUserGroup(userGroupId: any, params: any) {
    try {
        const res = await http.put(`groups/${userGroupId}/permission`, params);

        if(res.status === 200) {
            return Promise.resolve(true)
        }
        return Promise.reject(new Error(`Couldn't update userGroup permission change`))
    } catch (error) {
        return Promise.reject(new Error(`Couldn't update userGroup permission change`))
    }
}

export async function getAllUserGroupsForWorkspace(appId: string, params:any, options?: { signal?: AbortSignal }): Promise<PaginatedResponse<IWorkspaceUserGroupData>> {
    const url = `apps/${appId}/groups`    
    try {
        const res = await http.get(url, {params, signal: options?.signal});

        if(res) {
            return Promise.resolve(res.data)
        } 
    } catch (error) {
        throw error;
    }
}

export async function getAllUserGroupsForAddNewGroupModal(appId: string, params:any, options?: { signal?: AbortSignal }): Promise<PaginatedResponse<IWorkspaceUserGroupData>> {
    const url = `apps/${appId}/groups/availableToAdd`    
    
    try {
        const res = await http.get(url, {params, signal: options?.signal});
        
        if(res) {
            return Promise.resolve(res.data)
        } 
    } catch (error) {
        throw error;
    }
}


export async function updateUserGroupPermissionForWorkspace(appId: string, userGroupId: number, params: any) {
    try {
        const res = await http.put(`apps/${appId}/groups/${userGroupId}`, params);

        if(res.status === 200) {
            return Promise.resolve(true)
        }
        return Promise.reject(new Error(`Couldn't update userGroup permission change`))
    } catch (error) {
        return Promise.reject(new Error(`Couldn't update userGroup permission change`))
    }
}


export async function removeUserGroupFromWorkspaceAccess(appId: string, userGroupId: any) {
    try {
         const res = await http.delete(`apps/${appId}/groups/${userGroupId}`);

        if(res.status === 200) {
            return Promise.resolve(true)
        }
        return Promise.reject(new Error(`Couldn't restrict user group access from this workspace`))
    } catch (error) {
        return Promise.reject(new Error(`Couldn't restrict user group access from this workspace`))
    }
}

export async function addAllUsersGroupToWorkspace(appId: string): Promise<any> {
    const url = `apps/${appId}/addAllUsersGroup`    
    const res = await http.put(url, "");

    if(res) {
        return Promise.resolve(res.data)
    } 
    return Promise.reject(new Error(`Couldn't add all user groups to workspace`))
}

export async function getWorkspacesForUserGroup(userGroupId: any, params:any, options?: { signal?: AbortSignal }): Promise<PaginatedResponse<IUserWorkspaceData>> {
    const url = `groups/${userGroupId}/apps`    
    const res = await http.get(url, {params, signal: options?.signal});

    if(res) {
        return Promise.resolve(res.data)
    } 
    return Promise.reject(new Error(`Couldn't get workspace data`))
}
